import projectOptions from "src/shared/project-options";
import { store } from "../store";
import getCurrencyFromJson from "./get-currency-from-json";

const regexObjectBrackets = /{(.*?)}/;
class CurrencyFormatter {
  formatPattern: string = "";
  splitter: string = "";
  showPennies: boolean = false;
  constructor(private currencyExpression: string) {
    if (!this.currencyExpression) {
      return;
    }

    const _searchValue =
      this.currencyExpression.match(regexObjectBrackets) || [];
    const _formatterPattern = _searchValue?.length > 1 ? _searchValue[1] : "";
    this.formatPattern = _formatterPattern.split("").reverse().join("");
    this.splitter = this.getSplitterFromPattern(this.formatPattern);
    this.showPennies = !this.formatPattern.includes("-");
  }

  // find if penny digit is spilitted by comma or semicolon
  // if pattern is xxx.xxx,-- then pennies wont be shown
  getSplitterFromPattern(pattern: string) {
    let done = false;
    let index = 0;
    let splitter = "";

    while (!done) {
      const currentChar = pattern[index];
      if (currentChar === "." || currentChar === ",") {
        splitter = currentChar;
        done = true;
      } else if (index >= pattern.length) {
        done = true;
      } else {
        index++;
      }
    }

    return splitter;
  }

  format(_value: number): string {
    if (!this.formatPattern || !this.splitter) return _value.toString();

    const [valueLeft, valueRight] = _value.toFixed(2).split(".");
    let [patternRight, patternLeft] = this.formatPattern.split(this.splitter);
    let valueLeftReversed = valueLeft.split("").reverse().join("");
    let result = "";
    let index = 0;
    let patternIndex = 0;
    let isFormatted = false;

    while (!isFormatted) {
      let currentPattern = patternLeft[patternIndex];
      const currentValue = valueLeftReversed[index];
      const nextValue = valueLeftReversed[index + 1];
      if (!currentValue) {
        isFormatted = true;
        break;
      }

      if (currentPattern === "x") {
        result += currentValue ?? "";
      } else {
        result += currentPattern ?? "";
        result += currentValue ?? "";
        if (nextValue) {
          result += nextValue;
        }
        index++;
        patternIndex += 2;
      }

      index++;
      patternIndex++;
    }

    const finalResult = result.split("").reverse().join("");
    const finalResultWithPennies = finalResult + this.splitter + valueRight;
    const replacedResult = this.showPennies
      ? this.currencyExpression.replace(
          regexObjectBrackets,
          finalResultWithPennies
        )
      : this.currencyExpression.replace(regexObjectBrackets, finalResult);

    const { currencyCode, useCurrencyAfterPrice, useCurrencySymbol } =
      getCurrencyFromJson();

    if (useCurrencyAfterPrice) {
      return replacedResult + " " + currencyCode;
    } else {
      return currencyCode + " " + replacedResult;
    }
  }
}

function getCurrencyFormatter() {
  const currencyFormatter = new CurrencyFormatter(
    projectOptions.default.style.product.currency
  );
  return currencyFormatter;
}

export default getCurrencyFormatter;
